import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { categorySet }  from '../../store/categorySlice';
import useApi from '../../hooks/useApi';
import { compare } from '../../utils/categories';
import useCategories from '../../hooks/useCategories';
//
// Компонент выводит списки категорий мероприятия
//
const EventCategoriesList = ({ event }) => {
	const { t } = useTranslation();
    const navigate = useNavigate();
    const [ params ] = useState({ event: event._id });
	const [ data, error, isLoading ] = useApi({ type: 'get', method: '/categories', params });
    const { addon, admin, folders, orphans } = useCategories({ categories: data?.categories });

    return (
    <div>
        {error && <div className='error'>{t(error)}</div>}
        {isLoading && <div>{t('loader.title')}</div>}

        <h2>
            {t('eventview.categories')}
            <span onClick={() => navigate('/cabinet/categoryadd')}>{t('common.add')}</span>
        </h2>

        <CategoriesMain folders={folders} orphans={orphans}/>
        <CategoriesOther list={addon} header='eventview.cataddon' noitems='eventview.nocataddon'/>
        <CategoriesOther list={admin} header='eventview.catadmin' noitems='eventview.nocatadmin'/>

    </div>
	);
};

EventCategoriesList.propTypes = {
    event: PropTypes.object.isRequired,
};

//
// Выводит основную категорию
//
const CategoriesMain = ({ folders, orphans }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onClick = (category) => {
        dispatch(categorySet(category));
        navigate('/cabinet/categoryedit');
    };

    return (
        <div>
            <div className='b'>
                {t('eventview.catmain')}
            </div>
        
            {(folders.length > 0 || orphans.length > 0) &&
            <ul>
                {folders.map(item => (
                    <li key={item._id}>
                        <span className='a' onClick={() => onClick(item)}>{item.name[lang]}</span>&nbsp;
                        <span style={{color:'var(--gray-color)'}} className='small'>({item.priority})</span>
                        <CategoriesList list={item.categories}/>
                    </li>
                ))}
                {orphans.length > 0 &&
                <li>
                    <span>{t('eventview.nofolder')}</span>
                    <CategoriesList list={orphans}/>
                </li>}
            </ul>}

            {(folders.length === 0 && orphans.length === 0) && <ul><li>{t('eventview.nocatmain')}</li></ul>}
        </div>
    );
};

//
// Выводит списк категорий admin или addon
//
const CategoriesOther = ({ list, header, noitems }) => {
    const { t } = useTranslation();
    return (
        <div>
            <div className='b'>{t(header)}</div>
            <CategoriesList list={list}/>
            {list.length === 0 && <ul><li>{t(noitems)}</li></ul>}
        </div>
    );
};

//
// Выводит список категорий
//
const CategoriesList = ({ list }) => {
	const { i18n } = useTranslation();
    const lang = i18n.language;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [ sorted, setSorted ] = useState([]);

    useEffect(() => {
        list.sort((a, b) => compare(a, b, lang));
        setSorted(list);
    }, [ list, lang ]);

    const onClick = (category) => {
        dispatch(categorySet(category));
        navigate('/cabinet/categoryedit');
    };

    if(!list.length) return null;

    return(
        <ul>
            {sorted.map(item => (
                <li key={item._id}>
                    <span className='a' onClick={() => onClick(item)}>{item.name[lang]}</span>&nbsp;
                    <span style={{color:'var(--gray-color)'}} className='small'>({item.priority})</span>
                </li>
            ))}
        </ul>
    );
};

export default EventCategoriesList;
